import { render } from "./EventRow.vue?vue&type=template&id=99653bdc&scoped=true"
import script from "./EventRow.vue?vue&type=script&lang=js"
export * from "./EventRow.vue?vue&type=script&lang=js"

import "./EventRow.vue?vue&type=style&index=0&id=99653bdc&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99653bdc"]])

export default __exports__